<div class="modal locationPermission d-block" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered m-auto" role="document">
      <div class="modal-content">
        <div class="modal-body p-0">
        <div  class="welcome-gif">
          <img src="../../../../assets/first_stop_infopage.gif"/>
        </div>
         <h1 class="text-left pt-4">{{welcomeTourStopTranslation['title']}}</h1>
         <p class="font-weight-normal text-left">{{welcomeTourStopTranslation['content1']}}</p>
         <p class="font-weight-normal text-left">{{welcomeTourStopTranslation['content2']}}</p>
         <button class="d-flex align-items-center continue-btn font-weight-bold fs-3" (click)="hide.emit()">
          <img src="../../../assets/check.svg" class="pr-2" alt="">{{welcomeTourStopTranslation['btnContent']}}
        </button>
        </div>
      </div>
    </div>
</div>
